// extracted by mini-css-extract-plugin
module.exports = {"bar":"TopBar_bar__r-cTX","barMobile":"TopBar_barMobile__SBuwA","menuIcon":"TopBar_menuIcon__oBJfK","title":"TopBar_title__2Ebdn"};